
import React, {useState, useCallback, useContext} from 'react'
import defaultState from './config'
import {useDropzone} from 'react-dropzone'
import Dropzone from './Dropzone'
import UploadFileList from './UploadFileList'
import SubmissionModal from './SubmissionModal'
import {uploadPaAttachments} from '../../shared/api-service'
import {apiStatus} from '../../shared/enums'
import PriorAuthorizationContext from '../../contexts/PriorAuthorization/PriorAuthorization.context'
import AppContext from '../../contexts/App/App.context'

export default function useUploadHelper(props={}){
  //handleSubmit, uploadStatus, modalTitle, ...uploadInfo

    const { 
        npiNumber, authNumber
    } = props
    
    const [state, setState] = useState({...defaultState})

    const {inquiry: {data}} = useContext(PriorAuthorizationContext)
    const { provider: {providerType} } = useContext(AppContext)
    const removeFile = (index) => {
        setState( prev => {
            const newFiles = Array.from(prev.files)
            newFiles.splice(index, 1)
            const change = { operation: 'remove', delta: 1 }
            return { ...prev, change, files: newFiles }
        })
    }
    const fileContainsSpecial = ({isTooManyFiles, isFileTooBig, acceptedFiles}) => {
        if (!isTooManyFiles && !isFileTooBig && acceptedFiles.length > 0) {
          for (const file of acceptedFiles) {
            const fileNameWithoutExtension = file.name
            .split(".")
            .shift();
            const isValid = /[^\p{L}\p{N}._-]/u.test(fileNameWithoutExtension);
            if (isValid) {
              return true;
            }
          }
        }
        return false;
    }
    const isInValidFileTypes = (fileRejections) => {
           if (fileRejections.length > 0 && "errors" in fileRejections[0]) {
             if (fileRejections[0].errors[0].code === 'file-invalid-type') {
               return true
             } 
           } else {
             return false
           }
    }
    const onDrop = useCallback(
      (acceptedFiles, fileRejections) => {
        setState((prev) => {
          const isTooManyFiles =
            acceptedFiles.length + prev.files.length > state.maxNumFiles;
          const isFileTooBig = fileRejections.some(
            ({ file }) => file.size >= state.maxFileSize
          );
          const fileContainsSpecialCharacter = fileContainsSpecial({
            isTooManyFiles,
            isFileTooBig,
            acceptedFiles,
          });
          const invalidFileTypes = isInValidFileTypes(fileRejections);
        
               if (
                 isFileTooBig ||
                 isTooManyFiles ||
                 fileContainsSpecialCharacter ||
                 invalidFileTypes
               ) {
                 return {
                   ...prev,
                   isFileTooBig,
                   isTooManyFiles,
                   fileContainsSpecialCharacter,
                   invalidFileTypes,
                   change: { operation: "rejected" },
                 };
               } else {
                 acceptedFiles.forEach(
                   (f) => (f.uploadDate = new Date().toString())
                 );
                 return {
                   ...prev,
                   isFileTooBig: false,
                   isTooManyFiles: false,
                   fileContainsSpecialCharacter: false,
                   invalidFileTypes: false,
                   files: prev.files.concat(acceptedFiles.map((f) => f)),
                   change: { operation: "add", delta: acceptedFiles.length },
                 };
               }
        });
      },
      [state.maxFileSize, state.maxNumFiles]
    );


    const DZone = (props) => 
        <Dropzone 
            dzoneProps={{...useDropzone({ accept: props.accept, disabled: props.disabled, onDrop, maxSize: state.maxFileSize})}} 
            {...props}
        />

    const FileList = (props) => 
        <UploadFileList 
            listProps={{
                removeFile: props.disabled ? null : removeFile,
                files: state.files,
            }}
            {...props}
        />

    const Modal = (props) => 
        <SubmissionModal 
            modalProps={{
                isModalOpen: props.open && state.isModalOpen,
                setIsModalOpen: (val) => setState( prev => ({...prev, isModalOpen: val}) ),
                status: state.uploadStatus,
                error: state.uploadErrorCode,
                modalTitle: state.modalTitle
            }}
            {...props}
        />

    const handleSubmit = async () => {
        setState( prev => ({...prev, isModalOpen: true, uploadStatus: apiStatus.LOADING , modalTitle: 'Submitting files for upload...'}))
        try{
            const uploadPayload = {...data[0]}
            uploadPayload.providerType = providerType
            const {status} = await uploadPaAttachments(npiNumber, authNumber, state.files, uploadPayload)
            let modalStatus = apiStatus.ERROR
            let title = 'Oops! An error occurred!'
            if(status === 200){
                modalStatus = apiStatus.SUCCESS
                title = 'Your file(s) were successfully uploaded.'
            }
            setState( prev => ({...prev, uploadStatus: modalStatus, modalTitle: title}))
        }
        catch(error){
            setState( prev => ({...prev, uploadStatus: apiStatus.ERROR, modalTitle: error.message}))
        }
    }

    const setFiles = (props) => {
        const {files, isFileTooBig=false, isTooManyFiles=false} = props
        setState( prev => ( { ...prev, files, isFileTooBig, isTooManyFiles } ) )
    }

    const clearErrors = (
      isFileTooBig = false,
      isTooManyFiles = false,
      fileContainsSpecialCharacter = false,
      invalidFileTypes=false
    ) => {
      setState((prev) => ({
        ...prev,
        isFileTooBig,
        isTooManyFiles,
        fileContainsSpecialCharacter,
        invalidFileTypes
      }));
    };

    return { DZone, FileList, Modal, handleSubmit, setFiles, clearErrors, ...state }
}